module.exports = __webpack_public_path__ + "images/newerp_button2.1792157180594.png";